export const buttonTokens = {
  'button-primary-bg': 'var(--dp-color-primary)',
  'button-primary-bg-hover': 'var(--dp-color-primary-hover)',
  'button-primary-bg-active': 'var(--dp-color-primary-active)',
  'button-primary-text': 'var(--dp-color-text-inverse)',
  'button-primary-border': 'transparent',
  'button-secondary-bg': 'transparent',
  'button-secondary-bg-hover': 'var(--dp-color-surface-hover)',
  'button-secondary-text': 'var(--dp-color-primary)',
  'button-secondary-border': 'var(--dp-color-primary)',
  'button-danger-bg': 'var(--dp-color-error)',
  'button-danger-bg-hover': '#c0392b',
  'button-danger-text': 'var(--dp-color-text-inverse)',
  'button-danger-border': 'transparent',
  'button-ghost-bg': 'transparent',
  'button-ghost-bg-hover': 'var(--dp-color-surface-hover)',
  'button-ghost-text': 'var(--dp-color-text)',
  'button-ghost-border': 'transparent',
  'button-height-sm': '28px',
  'button-height-md': '36px',
  'button-height-lg': '44px',
  'button-padding-x-sm': 'var(--dp-spacing-md)',
  'button-padding-x-md': 'var(--dp-spacing-lg)',
  'button-padding-x-lg': 'var(--dp-spacing-xl)',
  'button-font-size': 'var(--dp-font-size-md)',
  'button-font-weight': 'var(--dp-font-weight-semibold)',
  'button-border-radius': 'var(--dp-border-radius-md)',
  'button-disabled-opacity': '0.5',
  'button-gap': 'var(--dp-spacing-sm)',
  'button-icon-size': '16px',
} as const;
